import { ReactNode } from "react";

import { ButtonBase } from "@mui/material";

interface Props {
  onClick: () => void;
  children: ReactNode;
}

/**
 * The keyboard- and screen-reader-reachable primary action of a clickable row. The row itself must
 * stay a plain container: as a button it would turn the links and buttons inside it into
 * nested-interactive controls (WCAG 4.1.2). Rendered as a div with role="button" because the row
 * titles (EllipsisText) are block content, which a native `<button>` must not contain.
 */
export function RowActionButton({ onClick, children }: Props) {
  return (
    <ButtonBase
      component="div"
      disableRipple
      onClick={onClick}
      sx={{
        display: "block",
        width: "100%",
        minWidth: 0,
        textAlign: "left",
        "&:focus-visible": { outline: 2, outlineColor: "primary.main", outlineOffset: 2 },
      }}
    >
      {children}
    </ButtonBase>
  );
}
